import _pickBy from 'lodash/pickBy';

const updateCommissionSanitizer = (params, excludedStrings = []) =>
  _pickBy(params, value =>
    value !== undefined &&
    value !== null &&
    (value === false || value === 0 || Boolean(value)) &&
    !['--'].includes(value)
  );

export default updateCommissionSanitizer;